/* Eliora Necklace builder: 1 to 7 round birthstone pendants stacked side by side in a smile on the chain.
   Pendant count is a dropdown with prices that drives the theme's hidden "Pendants" buttons (and so the variant/price).
   Each pendant gets a birthstone from 12 stones (6 + 6), one pendant open at a time. The live preview is its own slide
   in the photo gallery (same as Sora and Versana): built in the shopper's browser, never saved as product media.
   Before a count is chosen that slide shows an example necklace with five pendants.
   The preview uses the studio photo for the chosen count and metal, with each stone painted in its birthstone colour.
   Line-item properties keep exactly the names and values sent before: "Pendant 1" ... "Pendant 7" and "_Supplier SKU". */
(function () {
  'use strict';
  var root = document.querySelector('[data-eliora]');
  if (!root || root.__el) return;
  root.__el = true;
  var CFG = JSON.parse(root.getAttribute('data-cfg'));
  var GEO = {"T":108,"size":1254,"slots":{"1":[[571,938]],"2":[[515,938],[626,938]],"3":[[458,900],[572,926],[687,900]],"4":[[401,896],[512,940],[632,940],[742,896]],"5":[[382,838],[470,881],[572,898],[674,880],[761,836]],"6":[[339,788],[417,859],[516,897],[628,897],[728,858],[806,788]],"7":[[298,748],[374,821],[462,876],[570,914],[674,876],[764,821],[842,748]]}};          // { T: tile size, size: photo size, slots: { n: [[x, y] top-left of each stone tile, left to right] } }
  var MAX = 7, EMPTY = 12;        // sprite column 12 = the frosted "not chosen yet" stone

  var STONES = ['January - Garnet', 'February - Amethyst', 'March - Aquamarine', 'April - Diamond', 'May - Emerald', 'June - Alexandrite',
    'July - Ruby', 'August - Peridot', 'September - Sapphire', 'October - Pink Tourmaline', 'November - Topaz', 'December - Zircon'];
  /* supplier codes: chain by finish, one pendant code per stone (month number; April is 0) */
  var MONTH_CODE = ['1', '2', '3', '0', '5', '6', '7', '8', '9', '10', '11', '12'];

  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  var S = { count: 0, stones: [null, null, null, null, null, null, null] };   // choices are kept for all 7, so changing the count never loses them
  var HOV = null;                                                            // { k, m } while a swatch is hovered (desktop)
  var OPEN = -1;                                                             // the pendant whose stones are showing (one at a time)
  var wasDone = false;
  var q = function (s) { return root.querySelector(s); };
  var sel = q('[data-el-count]'), rowsEl = q('[data-el-rows]'), errEl = q('[data-el-error]');

  function finishValue() { var r = document.querySelector('fieldset[data-handle="finish"] input:checked'); return r ? r.value : CFG.finish; }
  function fin() { return /silver/i.test(finishValue()) ? 'silver' : 'gold'; }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function firstEmpty() { for (var k = 0; k < S.count; k++) if (S.stones[k] === null) return k; return -1; }
  function nextEmpty(k) {   // the next pendant still to choose: after k first, then any earlier one
    for (var i = k + 1; i < S.count; i++) if (S.stones[i] === null) return i;
    return firstEmpty();
  }
  function complete() { return S.count > 0 && firstEmpty() < 0; }
  function stoneName(m) { var p = STONES[m].split(' - '); return p[1] + ' - ' + p[0]; }   // "Garnet - January"

  /* ---------- pendant count dropdown (price per option follows the chosen metal) ---------- */
  function counts() {
    var out = [];
    Array.prototype.forEach.call(document.querySelectorAll('fieldset[data-handle="pendants"] input'), function (r) {
      var n = parseInt(r.value, 10); if (n >= 1 && n <= MAX && out.indexOf(n) < 0) out.push(n);
    });
    if (!out.length) Object.keys(CFG.prices || {}).forEach(function (k) { var n = parseInt(k.split('|')[1], 10); if (n >= 1 && n <= MAX && out.indexOf(n) < 0) out.push(n); });
    return out.sort(function (a, b) { return a - b; });
  }
  function drawCount() {
    var f = finishValue(), keep = S.count;
    sel.innerHTML = '';
    var ph = el('option', null, 'Select number of pendants'); ph.value = ''; ph.disabled = true; if (!keep) ph.selected = true;
    sel.appendChild(ph);
    counts().forEach(function (c) {
      var o = document.createElement('option'), p = CFG.prices && CFG.prices[f + '|' + c];
      o.value = c; o.textContent = c + (c === 1 ? ' pendant' : ' pendants') + (p ? '  —  ' + p : '');
      if (c === keep) o.selected = true;
      sel.appendChild(o);
    });
  }
  function syncTheme(n) {
    var r = document.querySelector('fieldset[data-handle="pendants"] input[value="' + n + '"]');
    if (r && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); r.dispatchEvent(new Event('input', { bubbles: true })); }
  }

  /* ---------- one row per pendant: a slim header (stone, name) that opens its 12 stones in two rows of 6 ---------- */
  function swatchStyle(m) { return 'background-image:url(' + CFG.urls.swatches[fin()] + ');background-position:' + (m / 11 * 100) + '% 50%'; }
  function buildRows() {
    rowsEl.innerHTML = '';
    rowsEl.appendChild(el('p', 'el-label el-rows__title', '<span>Your birthstones</span>'));
    for (var k = 0; k < MAX; k++) {
      var row = el('div', 'el-row el-empty'); row.setAttribute('data-el-row', k); row.hidden = true;
      var head = el('button', 'el-row__head'); head.type = 'button'; head.setAttribute('data-el-head', k);
      head.setAttribute('aria-expanded', 'false'); head.setAttribute('aria-controls', 'el-panel-' + k);
      head.innerHTML = '<span class="el-dot" data-el-dot>' + (k + 1) + '</span>' +
        '<span class="el-row__text"><span class="el-row__num">Pendant ' + (k + 1) + ':</span><span class="el-picked" data-el-picked>Choose a birthstone</span></span>' +
        '<span class="el-chev" aria-hidden="true"></span>';
      row.appendChild(head);
      var panel = el('div', 'el-panel'); panel.id = 'el-panel-' + k; panel.hidden = true;
      var wrap = el('div', 'el-swatches'); wrap.setAttribute('role', 'group'); wrap.setAttribute('aria-label', 'Pendant ' + (k + 1) + ' birthstone');
      for (var m = 0; m < 12; m++) {
        var b = el('button', 'el-swatch'); b.type = 'button';
        b.setAttribute('data-k', k); b.setAttribute('data-m', m);
        b.title = stoneName(m); b.setAttribute('aria-label', stoneName(m) + ' for pendant ' + (k + 1)); b.setAttribute('aria-pressed', 'false');
        b.innerHTML = '<span class="el-gem"></span><span class="el-month">' + MONTHS[m] + '</span>';
        wrap.appendChild(b);
      }
      panel.appendChild(wrap);
      row.appendChild(panel);
      rowsEl.appendChild(row);
    }
  }
  function drawRows() {
    if (OPEN >= S.count) OPEN = -1;
    rowsEl.classList.toggle('el-open', S.count > 0);
    Array.prototype.forEach.call(rowsEl.querySelectorAll('[data-el-row]'), function (row) {
      var k = +row.getAttribute('data-el-row'), m = S.stones[k], open = k === OPEN;
      row.hidden = k >= S.count;
      row.classList.toggle('el-empty', m === null);
      row.classList.toggle('is-open', open);
      row.querySelector('[data-el-head]').setAttribute('aria-expanded', open ? 'true' : 'false');
      row.querySelector('.el-panel').hidden = !open;
      row.querySelector('[data-el-picked]').textContent = m === null ? 'Choose a birthstone' : stoneName(m);
      var dot = row.querySelector('[data-el-dot]');
      if (m === null) { dot.removeAttribute('style'); dot.textContent = k + 1; }
      else { dot.setAttribute('style', swatchStyle(m)); dot.textContent = ''; }
      Array.prototype.forEach.call(row.querySelectorAll('.el-swatch'), function (b) {
        var bm = +b.getAttribute('data-m');
        b.firstChild.setAttribute('style', swatchStyle(bm));
        b.setAttribute('aria-pressed', bm === m ? 'true' : 'false');
      });
    });
  }

  /* ---------- line-item properties inside the real product form ---------- */
  function productForm() {
    var ref = document.querySelector('fieldset[data-handle="finish"] input[type="radio"], fieldset[data-handle="pendants"] input[type="radio"]');
    var id = ref && ref.getAttribute('form');
    return (id && document.getElementById(id)) || document.querySelector('form[action*="/cart/add"]');
  }
  function supplierSku() {
    var f = fin(), fc = f === 'gold' ? 'D' : 'A', parts = ['YX26925' + fc + '0W0'];
    for (var i = 0; i < S.count; i++) if (S.stones[i] !== null) parts.push('YP36094' + fc + '2B' + MONTH_CODE[S.stones[i]]);
    return parts.join(' + ');
  }
  function syncProps() {
    var form = productForm(); if (!form) return;
    for (var i = 1; i <= MAX; i++) {
      var name = 'properties[Pendant ' + i + ']', h = form.querySelector('input[name="' + name + '"]');
      if (i <= S.count) {
        if (!h) { h = document.createElement('input'); h.type = 'hidden'; h.name = name; form.appendChild(h); }
        var v = S.stones[i - 1] === null ? '' : STONES[S.stones[i - 1]];
        if (h.value !== v) h.value = v;
      } else if (h) { h.remove(); }
    }
    var sk = form.querySelector('input[name="properties[_Supplier SKU]"]');
    if (!sk) { sk = document.createElement('input'); sk.type = 'hidden'; sk.name = 'properties[_Supplier SKU]'; form.appendChild(sk); }
    var sv = S.count ? supplierSku() : '';
    if (sk.value !== sv) sk.value = sv;
  }

  /* ---------- preview ---------- */
  var imgs = {};
  function load(u) {
    if (!imgs[u]) imgs[u] = new Promise(function (res, rej) {
      var im = new Image(); im.crossOrigin = 'anonymous'; im.decoding = 'async';
      im.onload = function () { res(im); }; im.onerror = function () { delete imgs[u]; rej(new Error(u)); }; im.src = u;
    });
    return imgs[u];
  }
  var SIZE = GEO.size, T = GEO.T;
  var cv = document.createElement('canvas'); cv.width = SIZE; cv.height = SIZE;
  cv.className = 'el-preview'; cv.setAttribute('role', 'img'); cv.setAttribute('aria-label', 'Preview of your Eliora necklace');
  function effective() { var s = S.stones.slice(); if (HOV) s[HOV.k] = HOV.m; return s; }
  function paint(n, base, sheet, stones) {
    var ctx = cv.getContext('2d'), sl = GEO.slots[n];
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.drawImage(base, 0, 0, SIZE, SIZE);
    for (var k = 0; k < n; k++) {
      var m = stones[k], col = m === null ? EMPTY : m, x = sl[k][0], y = sl[k][1];
      ctx.drawImage(sheet, col * T, k * T, T, T, x, y, T, T);
      if (m === null) {   // not chosen yet: a frosted stone with its pendant number, so the order is clear
        ctx.save();
        ctx.font = '600 38px "Helvetica Neue", Helvetica, Arial, sans-serif';
        ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        ctx.fillStyle = 'rgba(92,80,72,.78)';
        ctx.fillText(String(k + 1), x + T / 2, y + T / 2 + 2);
        ctx.restore();
      }
    }
  }

  /* ---------- the design as its own slide in the photo gallery (same as Sora and Versana) ----------
     Built in the shopper's browser only; never saved as product media, so feeds, catalogs and ads never see it.
     Before a count is chosen the slide shows an example necklace (five pendants, current metal); the snippet puts it
     first in the gallery before the theme starts it, so the page opens on it. Once a count is chosen it becomes
     "Your design". Shoppers can swipe to the photos and back; the thumbnail strip has it first. */
  var gal = (function () {
    var slide = null, thumb = null, tctx = null, exImg = null, exThumb = null;
    function sl() { var s = document.getElementById('Product-Slider'); return s && s.flkty && typeof s.reInit === 'function' ? s : null; }
    function strip() { return document.getElementById('Product-Thumbnails'); }
    function sfx(id) { return (id || '').replace(/^(Slide|Thumb)-/, ''); }
    /* the older one-photo-per-option pictures stay on the product (feeds and ads use them) but never show here:
       the gallery is the example/design plus the lifestyle photos */
    var OLD = '.product-images__slide-item--variant.is-active';
    function stale() { var s = document.getElementById('Product-Slider'), st = strip(); return !!((s && s.querySelector(OLD)) || (st && st.querySelector(OLD))); }
    function dropOld() {
      var s = document.getElementById('Product-Slider'), st = strip(), hit = false;
      if (!s || !s.querySelector('.product-images__slide.is-active:not(.product-images__slide-item--variant)')) return false;   // never leave the gallery empty
      [s, st].forEach(function (box) {
        if (!box) return;
        Array.prototype.forEach.call(box.querySelectorAll(OLD), function (e) { e.classList.remove('is-active', 'is-initial-selected', 'is-selected'); hit = true; });
      });
      return hit;
    }
    /* use the slide and thumbnail the snippet already placed, or make them */
    function make() {
      slide = document.getElementById('Slide-el-design');
      if (!slide) {
        slide = el('div', 'product-images__slide is-active el-slide is-example'); slide.id = 'Slide-el-design';
        slide.appendChild(el('div', 'product-single__media el-slide__media'));   // the theme expects this wrapper on every slide
      }
      thumb = document.getElementById('Thumb-el-design');
      if (!thumb) { thumb = el('div', 'product-thumbnail is-active el-thumb is-example'); thumb.id = 'Thumb-el-design'; }
      var media = slide.querySelector('.el-slide__media');
      exImg = media.querySelector('img.el-example');
      if (!exImg) {
        exImg = el('img', 'el-example'); exImg.width = exImg.height = SIZE; exImg.alt = 'Eliora Necklace with five birthstone pendants';
        media.insertBefore(exImg, media.firstChild);
      }
      media.appendChild(cv);
      media.appendChild(el('span', 'el-slide__tag', 'Your design'));
      exThumb = thumb.querySelector('img.el-example');
      if (!exThumb) { exThumb = el('img', 'el-example'); exThumb.alt = ''; thumb.insertBefore(exThumb, thumb.firstChild); }
      var tc = document.createElement('canvas'); tc.width = tc.height = 200; tctx = tc.getContext('2d');
      thumb.appendChild(tc);
      thumb.appendChild(el('span', 'el-thumb__tag', 'Your design'));
    }
    function index() {
      var s = sl(); if (!s || !slide) return -1;
      for (var i = 0; i < s.flkty.cells.length; i++) if (s.flkty.cells[i].element === slide) return i;
      return -1;
    }
    /* slide N must match thumbnail N (after a variant change the theme moves that variant's photo to the front
       while its thumbnail stays put, so thumbnail clicks would open the wrong photo) */
    function inOrder() {
      var s = sl(), st = strip(); if (!s || !st) return true;
      var th = st.querySelectorAll('.product-thumbnail.is-active'), cells = s.flkty.cells;
      if (th.length !== cells.length) return true;
      for (var i = 0; i < cells.length; i++) if (sfx(cells[i].element.id) !== sfx(th[i].id)) return false;
      return true;
    }
    /* rebuild the theme's slider with the slides in thumbnail order (design first); thumbnails are swapped for
       clean copies because the theme's click handlers remember each photo's old position */
    function rebuild() {
      dropOld();
      var s = sl(); if (!s) return false;
      var st = strip(), holder = s.querySelector('.flickity-slider') || s;
      if (st) {
        var byId = {};
        Array.prototype.forEach.call(s.querySelectorAll('.product-images__slide'), function (e) { byId[sfx(e.id)] = e; });
        Array.prototype.forEach.call(st.querySelectorAll('.product-thumbnail'), function (t) { var e = byId[sfx(t.id)]; if (e) holder.appendChild(e); });
        Array.prototype.slice.call(st.querySelectorAll('.product-thumbnail')).forEach(function (t) {
          if (t !== thumb) t.parentNode.replaceChild(t.cloneNode(true), t);
        });
      }
      s.reInit();
      return true;
    }
    /* make sure the slide is in the slider, first, with the photos in thumbnail order */
    function place() {
      var s = sl(); if (!s) return false;
      if (!slide) make();
      if (index() >= 0) { if (dropOld() || !inOrder()) rebuild(); return true; }
      var st = strip(); if (st && thumb.parentNode !== st) st.insertBefore(thumb, st.firstChild);
      var holder = s.querySelector('.flickity-slider') || s;
      holder.insertBefore(slide, holder.firstChild);
      slide.classList.add('is-active'); thumb.classList.add('is-active');
      return rebuild();
    }
    function mark() {
      var s = sl(), st = strip(); if (!s || !st) return;
      var act = st.querySelectorAll('.product-thumbnail.is-active');
      Array.prototype.forEach.call(st.querySelectorAll('.product-thumbnail.is-initial-selected'), function (t) { t.classList.remove('is-initial-selected'); });
      if (act[s.flkty.selectedIndex]) act[s.flkty.selectedIndex].classList.add('is-initial-selected');
    }
    function pick(select) {
      var s = sl(), i = index();
      if (select !== false && i >= 0 && s.flkty.selectedIndex !== i) s.flkty.select(i, false, true);
      mark();
    }
    return {
      present: function () { return index() >= 0; },
      /* the example necklace in the chosen metal (no count yet) */
      example: function (f, select) {
        if (!place()) return false;
        var u = CFG.urls.example && CFG.urls.example[f];
        if (u) {
          if (exImg.getAttribute('src') !== u) exImg.setAttribute('src', u);
          if (exThumb.getAttribute('src') !== u) exThumb.setAttribute('src', u);
        }
        slide.classList.add('is-example'); thumb.classList.add('is-example');
        pick(select);
        return true;
      },
      /* the shopper's design, freshly painted on the canvas */
      show: function (select) {
        if (!place()) return false;
        tctx.clearRect(0, 0, 200, 200); tctx.drawImage(cv, 226, 450, 800, 800, 0, 0, 200, 200);   // the stones
        slide.classList.remove('is-example'); thumb.classList.remove('is-example');
        pick(select);
        return true;
      },
      stale: stale,
      tidy: function () {
        if (!dropOld() && inOrder()) return;
        var s = sl(), keep = s && s.flkty.selectedElement;
        rebuild();
        s = sl(); if (s && keep) { var i = s.flkty.cells.map(function (c) { return c.element; }).indexOf(keep); if (i >= 0) s.flkty.select(i, false, true); }
        mark();
      },
      box: function () { var s = sl() || document.getElementById('Product-Slider'); return s ? s.getBoundingClientRect() : null; }
    };
  })();

  var token = 0, retries = 0;
  function render(select) {
    var n = S.count, t = ++token, f = fin();
    if (!n) {   // no count yet: the example necklace
      if (!gal.example(f, select) && retries++ < 20) setTimeout(function () { if (t === token) render(select); }, 250);   // the theme's gallery isn't ready yet
      return;
    }
    var stones = effective();
    Promise.all([load(CFG.urls.base[f][n - 1]), load(CFG.urls.stones[f][n - 1])]).then(function (im) {
      if (t !== token) return;
      paint(n, im[0], im[1], stones);
      if (!gal.show(select) && retries++ < 20) setTimeout(function () { if (t === token) render(select); }, 250);   // the theme's gallery isn't ready yet
    })['catch'](function (e) { if (window.console) console.warn('[eliora] preview', e); });
  }
  /* fetch what the current count and metal need, so picks and hovering feel instant */
  function warm() {
    var f = fin(); load(CFG.urls.swatches[f])['catch'](function () {});
    if (S.count) { load(CFG.urls.base[f][S.count - 1])['catch'](function () {}); load(CFG.urls.stones[f][S.count - 1])['catch'](function () {}); }
  }

  /* ---------- scrolling ---------- */
  function hh() { return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0; }
  /* keep the open pendant in view: its header near the top if needed, and its stones on screen */
  function scrollToRow(k) {
    requestAnimationFrame(function () {
      var r = rowsEl.querySelector('[data-el-row="' + k + '"]'); if (!r) return;
      var b = r.getBoundingClientRect(), vh = window.innerHeight || document.documentElement.clientHeight, top = hh() + 8, y = window.pageYOffset;
      if (b.top < top) window.scrollTo({ top: Math.max(0, b.top + y - top), behavior: 'smooth' });
      else if (b.bottom > vh - 12) window.scrollTo({ top: Math.max(0, Math.min(b.top + y - top, b.bottom + y - vh + 24)), behavior: 'smooth' });
    });
  }
  /* once every pendant has its stone, glide up to the finished necklace
     (skipped when it is already on screen, e.g. the sticky gallery on desktop) */
  function showPreview() {
    var r = gal.box(); if (!r) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    if (r.height && (Math.min(r.bottom, vh) - Math.max(r.top, 0)) / r.height >= 0.6) return;
    window.scrollTo({ top: Math.max(0, r.top + window.pageYOffset - hh() - 10), behavior: 'smooth' });
  }

  /* the theme would bring in the option's own photo on every metal or count change; on Eliora the design shows instead */
  function quiet() {
    Array.prototype.forEach.call(document.querySelectorAll('variant-selects, variant-radios'), function (v) {
      if (!v.__elQuiet) { v.__elQuiet = true; v.updateMedia = function () {}; }
    });
  }

  /* ---------- events ---------- */
  function setError(msg) {
    errEl.textContent = msg || ''; errEl.hidden = !msg; root.classList.toggle('el-invalid', !!msg);
  }
  rowsEl.addEventListener('click', function (e) {
    var h = e.target.closest && e.target.closest('[data-el-head]');
    if (h) {   // open or close a pendant
      var hk = +h.getAttribute('data-el-head');
      OPEN = OPEN === hk ? -1 : hk; HOV = null;
      drawRows();
      if (OPEN >= 0) scrollToRow(OPEN);
      return;
    }
    var b = e.target.closest && e.target.closest('.el-swatch'); if (!b) return;
    var k = +b.getAttribute('data-k'), m = +b.getAttribute('data-m');
    S.stones[k] = m; HOV = null;
    var done = complete();
    OPEN = done ? -1 : nextEmpty(k);          // move on to the next pendant still to choose; all chosen: fold them all up
    drawRows(); syncProps(); setError('');
    render();
    if (done && !wasDone) setTimeout(showPreview, 80);          // just finished: show them their necklace
    else if (OPEN >= 0) scrollToRow(OPEN);
    wasDone = done;
  });
  /* desktop: hovering a stone shows it on the necklace in that pendant's spot */
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches, hovT;
  if (canHover) {
    rowsEl.addEventListener('mouseover', function (e) {
      var b = e.target.closest && e.target.closest('.el-swatch');
      var next = b ? { k: +b.getAttribute('data-k'), m: +b.getAttribute('data-m') } : null;
      if (!next && !HOV) return;
      if (next && HOV && next.k === HOV.k && next.m === HOV.m) return;
      clearTimeout(hovT);
      hovT = setTimeout(function () { HOV = next; render(); }, next ? 40 : 140);
    });
    rowsEl.addEventListener('mouseleave', function () { clearTimeout(hovT); if (HOV) { HOV = null; render(); } });
  }
  sel.addEventListener('change', function () {
    S.count = parseInt(sel.value, 10) || 0;
    wasDone = complete();
    if (OPEN < 0 || OPEN >= S.count || S.stones[OPEN] !== null) OPEN = firstEmpty();
    drawRows(); syncProps(); setError(''); warm();
    if (OPEN >= 0) scrollToRow(OPEN);
    syncTheme(S.count);
    setTimeout(render, 60);
    setTimeout(function () { if (S.count) render(); }, 700);   // the theme jumps to the option's photo a moment later; bring the design back
  });
  /* the theme switches the variant (finish or count): redraw the design and swatches */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('fieldset[data-handle="finish"] input')) {
      drawCount(); drawRows(); syncProps(); warm(); setTimeout(render, 60);
    } else if (t.matches('fieldset[data-handle="pendants"] input')) {
      setTimeout(function () { if (S.count) render(); else gal.tidy(); }, 60);
    }
  });

  /* a count and a stone for every pendant are required before Add to bag / Buy it now */
  function guard(e) {
    var form = productForm(); if (!form) return;
    if (complete()) { syncProps(); return; }
    var t = e.target;
    if (e.type === 'submit' && t !== form) return;
    if (e.type === 'click') {
      var btn = t.closest && t.closest('button[type="submit"], button[name="add"], .shopify-payment-button__button, .shopify-payment-button [role="button"], [data-add-to-cart]');
      if (!btn) return;
      if (!form.contains(btn) && btn.getAttribute('form') !== form.getAttribute('id')) return;
    }
    e.preventDefault(); e.stopImmediatePropagation();
    if (!S.count) { setError('Choose how many pendants you would like.'); sel.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
    var fe = firstEmpty(), left = 0; for (var k = 0; k < S.count; k++) if (S.stones[k] === null) left++;
    setError('Choose a birthstone for pendant ' + (fe + 1) + (left > 1 ? ' (' + left + ' left).' : '.'));
    OPEN = fe; drawRows();
    var r = rowsEl.querySelector('[data-el-row="' + fe + '"]'); if (r) r.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  document.addEventListener('submit', guard, true);
  document.addEventListener('click', guard, true);

  /* the theme rebuilds parts of the product area on variant change; keep our inputs and the design slide in place */
  var moT;
  new MutationObserver(function () {
    clearTimeout(moT);
    moT = setTimeout(function () { quiet(); syncProps(); if (!gal.present()) render(false); else if (gal.stale()) gal.tidy(); }, 50);
  }).observe(document.body, { childList: true, subtree: true });

  quiet(); buildRows(); drawCount(); drawRows(); syncProps();
  (function first(n) {   // once the theme's gallery is up: the example first, and no option photo in it
    var s = document.getElementById('Product-Slider');
    if (s && s.flkty) render(false); else if (n < 40) setTimeout(function () { first(n + 1); }, 100);
  })(0);
  if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 2500 }); else setTimeout(warm, 1200);
})();
